export const selectUi = ({ ui }) => ui;
export const selectMobileSidebarExpanded = ({ ui }) =>
  ui?.mobileSidebarExpanded ?? false;
export const selectShouldConfirmNavigation = ({ ui }) =>
  ui?.shouldConfirmNavigation ?? false;
